import React from "react";
import { Link } from "react-router-dom";
import { getActiveCalc } from "@/lib/customCalc";
import { useBuilderLang } from "@/lib/builderStrings";

// Shown on Reports while a custom calculator is active (Phase 3 brings full custom reports).
export default function CustomReportsNotice() {
  const { b } = useBuilderLang();
  if (getActiveCalc() === "odisha") return null;
  return (
    <div className="rounded-2xl bg-thali-turmeric/15 border border-thali-turmeric/40 p-3 text-sm flex items-start gap-2" data-testid="custom-reports-soon">
      <span className="shrink-0 text-[10px] font-extrabold bg-thali-saffron text-white rounded-full px-2 py-0.5 mt-0.5">{b("coming_soon")}</span>
      <span>{b("reports_soon")} <Link to="/app/entry" className="font-semibold text-thali-green underline">{b("use_in_entry")}</Link></span>
    </div>
  );
}
